exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#statusFilter[data-v-146ae870] {\n    vertical-align: middle !important;\n}\n", ""]);

// exports
